import { Env } from "@stencil/core";

import { getFunctions, httpsCallable } from "firebase/functions";
import { firebase } from "global/firebase";

export function fbCallableFunction(name: string) {
	const functions = getFunctions(firebase, Env.functionsRegion);
	return httpsCallable(functions, name);
}
